import React from 'react';
import ForgotPasswordForm from './ForgotPasswordForm';
import SecondaryButton from 'components/buttons/SecondaryButton';
import logoGrey from 'assets/crafter-logo-grey.png';
import '../../style/scss/account.scss';

const ForgotPasswordPage = () => {
    return (
        <div className='container-center'>
            <div className='account-container'>
                <img src={logoGrey} alt="Logo" className='account-logo'/>
                <div className='account-form'>
                    <ForgotPasswordForm />
                </div>
                <div className='account-buttons'>
                    <SecondaryButton
                        label="account.back_to_login_button_label"
                        size="small"
                        route="/login" />
                </div>
            </div>
        </div>
    );
};

export default ForgotPasswordPage;